import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const ArrowLeftSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7859 5.22038C14.5284 4.93538 14.0809 4.93574 13.824 5.22115L8.32253 11.3309C7.98004 11.7112 7.98004 12.2888 8.32253 12.6691L13.767 18.7156C14.0545 19.0349 14.5549 19.0353 14.8429 18.7165C15.092 18.4407 15.092 18.0211 14.8429 17.7453L9.95564 12.3352C9.78368 12.1448 9.78368 11.8552 9.95564 11.6648L14.7859 6.31778C15.0674 6.00614 15.0674 5.53201 14.7859 5.22038Z"
				fill="currentColor"
			/>
		</SystemIconTemplate>
	)
})
